// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"86309aff","297":"6010d9fd","643":"e835f595","787":"1f6b82ec","959":"244c1cf0"}[chunkId] + ".chunk.js";
};